import React from 'react';
import styled from 'styled-components';

import { GoogleAdsTemplate } from './GoogleAdsTemplate';

const Root = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
`;

export const AdsLeadStory: React.FC = () => {
    return (
        <Root>
            <GoogleAdsTemplate
                adSizes={[
                    [1, 1],
                    [300, 250],
                ]}
                idSuffix="leadStory"
                network="/30443627/DocPage_Mobile_LeadStory"
            />
        </Root>
    );
};
